import client from "../client";

interface Request {
  start?: string;
  end?: string;
}

export interface ReportWithLossMemberForRankingResponse {
  Bet?: number;
  Turnover?: number;
  Com?: number;
  Username?: string;
  BetCount?: number;
  CreditFree?: number;
}

export default function API(
  request: Request
): Promise<ReportWithLossMemberForRankingResponse[]> {
  return client
    .get(`commission/report_wis_loss_member_for_ranking`, { params: request })
    .then((response) => response.data);
}
